import get_header from "workflow/requests/get_header"
import first from "rfuncs/functions/first"

export default r =>
    first(get_header(r, "content-type").split(";")).toLowerCase()
